import { FileText } from 'lucide-react'
import type { UseCompanyInfoTabReturn } from '@/features/company/types'
import styles from '../../../styles/companyAdd.module.css'
import { SectionCard } from '@/components/ui/SectionCard'

export function CompanyInfoFederalIdSection({
        register,
        canEditInfo,
        w9InputRef,
        w9File,
        setW9File,
        w9Uploading,
        uploadW9File,
        previewW9File,
        requestDeleteW9File,
        company,
        isPropertyRole,
}: UseCompanyInfoTabReturn) {
    return (
            <SectionCard
                icon={FileText}
                title="Federal ID"
                testId="company-info-section-federal-id"
            >
                <div className="flex flex-wrap items-start gap-6">
                        <div className={styles.formGroup} style={{ minWidth: "200px" }}>
                            <label className={styles.formLabel}>Federal ID Number</label>
                            <input
                                type="text"
                                disabled={!canEditInfo}
                                {...register("federal_id")}
                                data-testid="company-info-federal-id-input"
                                className={styles.customFormControl}
                             />
                        </div>
                        <div className={styles.formGroup} style={{ minWidth: "220px" }}>
                            <label className={styles.formLabel}>W-9 File</label>
                            <div className={styles.fileUploadInner} style={{
                                opacity: isPropertyRole ? 0.6 : 1,
                                cursor: isPropertyRole ? "not-allowed" : "pointer"
                            }}>
                                <input
                                    ref={w9InputRef}
                                    id="w9_file_input"
                                    type="file"
                                    accept=".pdf,.doc,.docx,.jpg,.png"
                                    data-testid="company-info-w9-file-input"
                                    className={styles.hiddenFileInput}
                                    disabled={w9Uploading || isPropertyRole}
                                    onChange={(e) => {
                                        const file = e.target.files?.[0]
                                        if (file) {
                                            setW9File(file)
                                            uploadW9File(file)
                                        }
                                    }}
                                />
                                <div
                                    className={styles.chatFilename}
                                    style={{
                                        cursor: isPropertyRole ? "not-allowed" : "pointer"
                                    }}
                                    onClick={() => !isPropertyRole && w9InputRef.current?.click()}
                                >
                                    {w9File?.name || (isPropertyRole ? "Upload disabled for property roles" : "Choose file...")}
                                </div>
                                <button
                                    type="button"
                                    data-testid="company-info-w9-upload-trigger-button"
                                    disabled={w9Uploading || isPropertyRole}
                                    className={styles.btnUpload}
                                    style={{
                                        cursor: (w9Uploading || isPropertyRole) ? "not-allowed" : "pointer",
                                    }}
                                    onClick={() => !isPropertyRole && w9InputRef.current?.click()}
                                >
                                    {w9Uploading ? "Uploading…" : "Upload"}
                                </button>
                            </div>
                            {company?.w9_file && typeof company.w9_file === "object" && Object.values(company.w9_file as Record<string, { id?: string | number; attachment_path?: string; attachment_name?: string }>).map((file) => (
                                file?.attachment_path && (
                                    <div key={file.id} style={{ display: "flex", alignItems: "center", gap: "8px", marginTop: "6px" }}>
                                        <button
                                            type="button"
                                            onClick={() =>
                                                file.id != null &&
                                                void previewW9File(file.id, file.attachment_name || 'W-9')
                                            }
                                            data-testid={`company-info-w9-existing-file-${file.id}-link`}
                                            className={styles.w9FileLink}
                                        >
                                            {file.attachment_name}
                                        </button>
                                        <button
                                            type="button"
                                            title="Delete"
                                            data-testid={`company-info-w9-existing-file-${file.id}-delete-button`}
                                            disabled={!canEditInfo || isPropertyRole}
                                            onClick={() => file.id != null && requestDeleteW9File(file.id)}
                                            style={{
                                                background: "none", border: "none", color: "#e74c3c",
                                                cursor: (canEditInfo && !isPropertyRole) ? "pointer" : "not-allowed", fontSize: "16px", padding: "0",
                                                opacity: (canEditInfo && !isPropertyRole) ? 1 : 0.5,
                                            }}
                                        >
                                            ✕
                                        </button>
                                    </div>
                                )
                            ))}
                        </div>
                    </div>
            </SectionCard>
    )
}
